'use client';
import React from 'react';
import Newsletter from '@/components/ui/Newsletter';
import { useNewsletter } from '@/hooks/useNewsletter';
import useStrapiHome from '@/hooks/useStrapiHome';

interface NewsletterSectionProps {
  className?: string;
  onSubmit?: (email: string) => void | Promise<void>;
  width?: string;
}

const NewsletterSection: React.FC<NewsletterSectionProps> = ({
  className = '',
  onSubmit,
  width = 'w-full',
}) => {
  const { data: strapiData } = useStrapiHome();
  const { subscribeAsync, isSubscribing, resetSubscribe } = useNewsletter();

  const newsletter = strapiData?.newsletterDesktop;

  if (newsletter && !newsletter.visible) {
    return null;
  }

  const handleNewsletterSubmit = async (email: string) => {
    if (onSubmit) {
      await Promise.resolve(onSubmit(email));
      return;
    }
    const trimmed = email.trim();
    if (!trimmed) return;
    try {
      resetSubscribe();
      await subscribeAsync({ email: trimmed });
    } catch {
      /* error: useNewsletter onError + subscribeError en el hook */
    }
  };

  return (
    <div data-component-id="src/components/sections/NewsletterSection.tsx:43:4" data-component-path="src/components/sections/NewsletterSection.tsx" data-component-line="43" data-component-file="NewsletterSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" className={className}>
      <div data-component-id="src/components/sections/NewsletterSection.tsx:44:6" data-component-path="src/components/sections/NewsletterSection.tsx" data-component-line="44" data-component-file="NewsletterSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%22%7D" className="w-full">
        <div data-component-id="src/components/sections/NewsletterSection.tsx:45:8" data-component-path="src/components/sections/NewsletterSection.tsx" data-component-line="45" data-component-file="NewsletterSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20w-full%22%7D" className="flex justify-center w-full">
          <Newsletter data-component-id="src/components/sections/NewsletterSection.tsx:46:10" data-component-path="src/components/sections/NewsletterSection.tsx" data-component-line="46" data-component-file="NewsletterSection.tsx" data-component-name="Newsletter" data-component-content="%7B%22elementName%22%3A%22Newsletter%22%7D"
            onSubmit={handleNewsletterSubmit}
            isSubmitting={!onSubmit && isSubscribing}
            width={width}
            titulo={newsletter?.titulo}
            descripcion={newsletter?.descripcion}
            objetoFondo={newsletter?.objetoFondo}
            objetoSuperior={newsletter?.objetoSuperior}
            objetoFondoAjuste={newsletter?.objetoFondoAjuste}
            objetoSuperiorPosicion={newsletter?.objetoSuperiorPosicion}
            alineacionTitulo={newsletter?.alineacionTitulo}
            posicionTitulo={newsletter?.posicionTitulo}
            fuenteTitulo={newsletter?.fuenteTitulo}
            boton={newsletter?.boton}
            textoBoton={newsletter?.textoBoton}
            url={newsletter?.url}
            colorFondoHex={newsletter?.colorFondoHex}
            colorTextoTituloHex={newsletter?.colorTextoTituloHex}
            colorTextoDescripcionHex={newsletter?.colorTextoDescripcionHex}
            posicionBoton={newsletter?.posicionBoton}
          />
        </div>
      </div>
    </div>
  );
};

export default NewsletterSection;
